import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';

const API_BASE = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : '');
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

axios.defaults.baseURL = API_BASE;

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('pf_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Session expired / invalid token → drop credentials and let the app bounce to /login.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    if (status === 401 && !url.includes('/auth/verify-google')) {
      localStorage.removeItem('pf_token');
      localStorage.removeItem('pf_user');
      sessionStorage.setItem('pf_session_expired', '1');
      window.dispatchEvent(new Event('pf:unauthorized'));
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);
